module.exports = __webpack_public_path__ + "img/IC_Descanso.8a49806a.svg";